<template>
  <app-modal
    :modal-id="modalId"
    modal-alignment="top"
    modal-size="fullscreen"
    @close-modal="closeModal"
  >
    <template slot="header">
      <h5 class="modal-title">{{modalTitle}}</h5>
    </template>
    <template slot="body">
      <form-preview v-if="show == true" :id="id" :form_id="form_id" :form_revision_id="form_revision_id" :taskId="task_id" :userId='user_id' :active="{ active }"></form-preview>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        {{ $t("close") }}
      </button>
      
    </template>
  </app-modal>
</template>

<script>
import { ModalMixin } from "@/app/Mixins/ModalMixin";
export default {
  name: "FormBuilderModal",
  mixins: [ModalMixin],
  props: {
    title: String,
    data: Object,
  },
  data() {
    return {
      modalId: 'bid-detail-show',
      id: 0,
      form_id: 0,
      form_revision_id: 0,
      task_id: 0,
      user_id: 0,
      show: false,
      active: true,
    };
  },
  created() {
    this.setData();
  },

  methods: {
    setData() {
      this.id = this.data.form_revision && this.data.form_revision.form_body_id?this.data.form_revision.form_body_id:this.$store.state.sharedData.sharedData.taskFormData.form_body_id;
      this.form_id = this.data.form_revision && this.data.form_revision.form_id?this.data.form_revision.form_id:this.$store.state.sharedData.sharedData.taskFormData.form_id;
      this.form_revision_id = this.data.form_revision && this.data.form_revision.id?this.data.form_revision.id:this.$store.state.sharedData.sharedData.taskFormRevisionId;
      this.task_id = this.data && this.data.task_id? this.data.task_id : this.$store.state.sharedData.sharedData.taskId;
      this.user_id = this.data && this.data.user_id? this.data.user_id : this.$store.state.sharedData.sharedData.guestFormData.id;
      this.show = true;
    }
  },
  
  mounted() {

    $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
  },
  computed:{
    modalTitle(){
      return this.title?this.$t(this.title):this.$t("Bid Detail");
    },
  }
};
</script>
